import React, {Dispatch, SetStateAction} from "react";
import CustomInput from "../CustomInput";
import {DescriptionFileInterface} from "../../../services/interface/DescriptionFileInterface";

interface Props {
    index: number,
    descriptions: DescriptionFileInterface[];
    setDescriptions: Dispatch<SetStateAction<DescriptionFileInterface[]>>;
}
export default function DescriptionFileInput({index, descriptions, setDescriptions}: Props) {

    return (
        <div className={'flex flex-row'}>
            <CustomInput
                labelFixel
                classNameContent={'my-2'}
                label={'description'}
                onChangeText={(e) => {
                    const text = descriptions.find(item => item.index === index);
                    if (text) {
                        setDescriptions(prev => prev.map((item) =>
                            ({...item, ...(index === item.index ? {description: e} : {})})));
                    } else {
                        setDescriptions(prev => [...prev, {index, description: e}]);
                    }
                }}
            />
        </div>
    )
}
